import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdminTokenInterceptor } from './core/auth/auth.interceptor';
import { RouterModule } from '@angular/router';

//Routes
import { routes } from './app.routes';

// service
import { AppService } from './core/config/app.service';

// store
import { StoreModule } from '@ngrx/store';
import { indexReducer } from './core/store/index.reducer';

// i18n
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// headlessui
import { MenuModule } from 'headlessui-angular';


// perfect-scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

// dashboard
import { IndexComponent } from './features/home/index';

// Layouts
import { AppLayout } from './layout/app-layout';
import { AuthLayout } from './layout/auth-layout';

import { HeaderComponent } from './layout/header';
import { FooterComponent } from './layout/footer';
import { SidebarComponent } from './layout/sidebar';
import { ThemeCustomizerComponent } from './layout/theme-customizer';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';

@NgModule({ 
    exports: [RouterModule], 
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
        BrowserModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MenuModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        StoreModule.forRoot({ index: indexReducer }),
        NgScrollbarModule,
        // NgScrollbarModule.withConfig({
        //     visibility: 'hover',
        //     appearance: 'standard',
        // }),
        HeaderComponent, FooterComponent, SidebarComponent, ThemeCustomizerComponent, IndexComponent, AppLayout, AuthLayout,
    ],
        providers: [
            AppService,
            Title,
            provideHttpClient(withInterceptorsFromDi()),
            provideFlatpickrDefaults(),
            { provide: HTTP_INTERCEPTORS, useClass: AdminTokenInterceptor, multi: true },
        ] })
export class AppModule {}

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
